import { Container } from "./styles";
import emailIcon from "../../assets/regular_icons/email-icon.svg";
import phoneIcon from "../../assets/regular_icons/phone-icon.svg";
import { Form } from "../Form/Form";

const contacts = [
  {
    href: "mailto:tilakved3898@gmail.com",
    icon: emailIcon,
    text: "tilakved3898@gmail.com",
    alt: "Email"
  },
  {
    href: "tel:+919484883898",
    icon: phoneIcon,
    text: "(+91) 9484883898",
    alt: "Phone No"
  }
];

export function Contact() {
  const handleAnimation = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = (e.currentTarget as HTMLElement);
    target.classList.add("animate");
    target.addEventListener("animationend", () => {
      target.classList.remove("animate");
    }, { once: true });
  };

  return (
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Ready to get started on your project?</p>
      </header>

      <div className="contacts">
        {contacts.map(({ href, icon, text, alt }, index) => (
          <div key={index} className="bubbly-button" onClick={handleAnimation}>
            <a href={href}><img src={icon} alt={alt} /></a>
            <a href={href}>{text}</a>
          </div>
        ))}
      </div>
      <Form />
    </Container>
  );
}